import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { TitanSprite } from "@lib/titan2/dist/game/control/TitanSprite";
import { TitanText } from "@lib/titan2/dist/game/control/TitanText";
import { EventObject } from "@lib/titan2/dist/util/event/EventObject";
import { FeatureType } from "../../../model/GameModel";
import { MouseUtil } from "@lib/titan2/dist/util/view/MouseUtil";
import { Service } from "@lib/titan2-slingo/dist/api/Service";
export class FeatureIntro extends AbstractGameView {
    constructor(factory, properties, portraitProperties) {
        super(factory, properties, portraitProperties);
    }
    create() {
        super.create();
        this.background = TitanSprite.createSprite(this, "background", this.landscapeProperties.background, this.portraitProperties?.background);
        this.icons = {
            5: TitanSprite.createSprite(this, "icon5", this.landscapeProperties.icons[5], this.portraitProperties?.icons[5]),
            6: TitanSprite.createSprite(this, "icon6", this.landscapeProperties.icons[6], this.portraitProperties?.icons[6]),
            7: TitanSprite.createSprite(this, "icon7", this.landscapeProperties.icons[7], this.portraitProperties?.icons[7]),
            8: TitanSprite.createSprite(this, "icon8", this.landscapeProperties.icons[8], this.portraitProperties?.icons[8]),
            9: TitanSprite.createSprite(this, "icon9", this.landscapeProperties.icons[9], this.portraitProperties?.icons[9]),
            10: TitanSprite.createSprite(this, "icon10", this.landscapeProperties.icons[10], this.portraitProperties?.icons[10]),
            12: {
                [FeatureType.GOLD_FISH]: TitanSprite.createSprite(this, "icon12_goldFish", this.landscapeProperties.icons[12][FeatureType.GOLD_FISH], this.portraitProperties?.icons[12][FeatureType.GOLD_FISH]),
                [FeatureType.FISH_FOOD]: TitanSprite.createSprite(this, "icon12_fishFood", this.landscapeProperties.icons[12][FeatureType.FISH_FOOD], this.portraitProperties?.icons[12][FeatureType.FISH_FOOD]),
            }
        };
        this.helpText = TitanText.createField(this, this.landscapeProperties.helpText, this.portraitProperties?.helpText);
        this.titleText = TitanText.createField(this, this.landscapeProperties.titleText, this.portraitProperties?.titleText);
        this.clickToSkipText = TitanText.createField(this, this.landscapeProperties.clickToSkipText, this.portraitProperties?.clickToSkipText);
        this.alpha = 0;
    }
    hideAllIcons() {
        Object.values(this.icons).forEach(icon => {
            if (icon instanceof TitanSprite) {
                icon.visible = false;
            }
            else {
                Object.values(icon).forEach(icon => icon.visible = false);
            }
        });
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(FeatureIntroEvents.FADE_IN, this.fadeIn);
        this.registerGame(FeatureIntroEvents.HIDE, this.handleHide);
    }
    updateInfo() {
        const type = this.model.featureTypeFromChanceGameConfigId(this.model.getChanceGameData()?.getGameConfigId() ?? "");
        this.hideAllIcons();
        const matches = this.model.getCurrentMatchedPatterns();
        if (matches < 12) {
            this.icons[matches].visible = true;
        }
        else {
            this.icons[12][type].visible = true;
        }
        let title = "";
        let info = "";
        switch (type) {
            case FeatureType.GREEN_FISH:
                title = this.langManager.getLang("GameLang.BONUS_CUPS_TITLE");
                info = `${this.langManager.getLang("GameLang.BONUS_CUPS_LINE1")}\n\n${this.langManager.getLang("GameLang.BONUS_CUPS_LINE2")}`;
                break;
            case FeatureType.RED_FISH:
                title = this.langManager.getLang("GameLang.BONUS_LADY_TITLE");
                info = `${this.langManager.getLang("GameLang.BONUS_LADY_LINE1")}\n\n${this.langManager.getLang("GameLang.BONUS_LADY_LINE2")}`;
                break;
            case FeatureType.PURPLE_FISH:
                title = this.langManager.getLang("GameLang.BONUS_HUNGRY_TITLE");
                info = `${this.langManager.getLang("GameLang.BONUS_HUNGRY_LINE1")}\n\n${this.langManager.getLang("GameLang.BONUS_HUNGRY_LINE2")}`;
                break;
            case FeatureType.GOLD_FISH:
                title = this.langManager.getLang("GameLang.BONUS_CLEO_TITLE");
                info = `${this.langManager.getLang("GameLang.BONUS_CLEO_LINE1")}\n\n${this.langManager.getLang("GameLang.BONUS_CLEO_LINE2")}`;
                break;
            case FeatureType.FISH_FOOD:
                title = this.langManager.getLang("GameLang.BONUS_TOTES_TITLE");
                info = `${this.langManager.getLang("GameLang.BONUS_TOTES_LINE1")}\n\n${this.langManager.getLang("GameLang.BONUS_TOTES_LINE2")}`;
                break;
            default:
                break;
        }
        this.titleText.setText(title, true);
        this.helpText.setText(info, true);
    }
    fadeIn() {
        this.updateInfo();
        gsap.to(this, {
            alpha: 1,
            duration: 1,
            onComplete: () => {
                this.handleInfoReady();
            }
        });
        this.clickToSkipText.alpha = 1;
        gsap.to(this.clickToSkipText, {
            alpha: 0.5,
            duration: 0.5,
            yoyo: true,
            repeat: -1,
            overwrite: true,
            ease: "linear",
            yoyoEase: "linear"
        });
    }
    handleInfoReady() {
        MouseUtil.setInteractive(this, Service.isReplay() ? false : true);
        MouseUtil.addMouseDown(this, this.handleClick, this);
    }
    handleClick() {
        this.dispatchGame(FeatureIntroEvents.CONTINUE);
    }
    handleHide() {
        gsap.killTweensOf(this.clickToSkipText);
        this.clickToSkipText.alpha = 0;
        MouseUtil.setInteractive(this, false);
        gsap.to(this, { alpha: 0, duration: 0.5 });
    }
}
export class FeatureIntroEvents {
}
FeatureIntroEvents.FADE_IN = new EventObject("FeatureIntroEvents.FADE_IN");
FeatureIntroEvents.CONTINUE = new EventObject("FeatureIntroEvents.CONTINUE");
FeatureIntroEvents.HIDE = new EventObject("FeatureIntroEvents.HIDE");
//# sourceMappingURL=GameFeatureIntro.js.map